module.exports = __webpack_public_path__ + "img/ico-key-facts.afd403e9.svg";